import React from "react";
import { useFormContext } from "react-hook-form";
import { FormValues } from "../types";
import { FilterDisplay } from "../Components/FilterDisplay";

export function FilterReview() {
  const {
    getValues,
    formState: { errors },
  } = useFormContext<FormValues>();
  const filters = getValues("filters");

  return <FilterDisplay filters={filters} errors={errors} />;
}
